import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { createLogger } from "logging";
import { environment } from "models/Environment";
import React, { PropsWithChildren } from "react";

import { AuthenticatedProvider } from "./AuthenticatedProvider";
import { defaultScopes } from "./AuthenticationContext";
import { AuthError } from "./AuthError";
import { AuthLoading } from "./AuthLoading";

const logger = createLogger("AuthenticationProvider");

const pca = new PublicClientApplication({
  auth: {
    clientId: environment.clientId,
    authority: `https://login.microsoftonline.com/${environment.tenantId}`,
    redirectUri: `${window.location.origin}/`,
  },
});

// Initialize the PublicClientApplication asynchronously without top-level await
pca
  .initialize()
  .then(() => {
    logger.debug("pca initialized");
  })
  .catch((err) => {
    logger.error("pca initialization failed", err);
  });

export const AuthenticationProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <MsalProvider instance={pca}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={{ scopes: defaultScopes }}
        errorComponent={() => <AuthError />}
        loadingComponent={() => <AuthLoading />}
      >
        <AuthenticatedProvider>{children}</AuthenticatedProvider>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};
